(function () {
  function updateMetaBundlePrice(root, variant) {
    if (!root) return;

    const sectionId = root.getAttribute("data-section-id");
    const jsonEl = document.getElementById("MetaBundlePricing-" + sectionId);
    if (!jsonEl) return;

    const priceEl = root.querySelector("[data-meta-bundle-price-current]");
    const compareEl = root.querySelector("[data-meta-bundle-compare]");
    const savingsEl = root.querySelector("[data-meta-bundle-savings]");

    if (!variant || !variant.id) {
      if (priceEl) priceEl.textContent = "";
      if (compareEl) {
        compareEl.textContent = "";
        compareEl.hidden = true;
      }
      if (savingsEl) savingsEl.hidden = true;
      return;
    }

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const entry = data.variants && data.variants[String(variant.id)];
    if (!entry) return;

    if (priceEl) {
      priceEl.textContent = entry.price_display || "";
    }

    if (compareEl) {
      if (entry.show_compare && entry.rrp_display) {
        compareEl.textContent = entry.rrp_display;
        compareEl.hidden = false;
      } else {
        compareEl.textContent = "";
        compareEl.hidden = true;
      }
    }

    if (savingsEl) {
      const savings = data.savings || "";
      if (entry.show_compare && savings) {
        savingsEl.textContent = savings;
        savingsEl.hidden = false;
      } else {
        savingsEl.textContent = "";
        savingsEl.hidden = true;
      }
    }
  }

  function initRoot(root) {
    const section = root.closest("[data-section-id]");
    if (!section) return;

    const productJson = section.querySelector('[id^="ProductJson-"]');
    if (!productJson) return;

    let product;
    try {
      product = JSON.parse(productJson.textContent);
    } catch (e) {
      return;
    }

    const variantId =
      product.selected_or_first_available_variant_id ||
      (product.selected_or_first_available_variant && product.selected_or_first_available_variant.id);

    const variant = (product.variants || []).find(function (v) {
      return v.id === variantId;
    });

    if (variant) updateMetaBundlePrice(root, variant);
  }

  document.querySelectorAll("[data-meta-bundle-price]").forEach(initRoot);

  document.addEventListener("product:variant-change", function (evt) {
    const variant = evt.detail && evt.detail.variant;
    document.querySelectorAll("[data-meta-bundle-price]").forEach(function (root) {
      updateMetaBundlePrice(root, variant);
    });
  });
})();
